import { render, staticRenderFns } from "./SliderComponent.vue?vue&type=template&id=bd8f7dfc&scoped=true"
import script from "./SliderComponent.vue?vue&type=script&lang=js"
export * from "./SliderComponent.vue?vue&type=script&lang=js"
import style0 from "./SliderComponent.vue?vue&type=style&index=0&id=bd8f7dfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd8f7dfc",
  null
  
)

export default component.exports